import React, { useEffect, useState } from 'react';
import { BoKNavigation } from 'lib/templates/Feature.BOKF.model';
import { useRouter } from 'next/router';

import EnhancedSearchWidget from 'widgets/EnhancedSearchWidget/EnhancedSearchWidget';
import WidgetWrapper from 'helpers/WidgetWrapper/WidgetWrapper';

type EnhancedSearchLandingProps = BoKNavigation.SiteSearch;

const EnhancedSearch = (props: EnhancedSearchLandingProps) => {
  const router = useRouter();
  const { SearchBarPlaceholderText } = props.fields || {};

  const [currentPageURL, setCurrentPageURL] = useState('');

  useEffect(() => {
    // Set currentPageURL only on the client side
    if (typeof window !== 'undefined') {
      setCurrentPageURL(`${window.location.origin}${router.asPath}`);
    }
  }, [router.asPath]);
  return (
    <WidgetWrapper>
      <EnhancedSearchWidget
        rfkId={'rfkid_7'}
        searchBarPlaceholderText={SearchBarPlaceholderText?.value}
        searchFormTarget={currentPageURL}
      />
    </WidgetWrapper>
  );
};
export default EnhancedSearch;
